import React from "react";
import "./DomainEmptyState.scss";

const EmptyState = (props) => {
    return (
        <div className={`empty-state-wrap ${props.wrapperClass}`}>
            <div className="empty-state">
                {props.stateIcon && (
                    <i className={`icon far ${props.stateIcon}`}></i>
                )}
                {props.stateTitle && (
                    <div className="title">{props.stateTitle}</div>
                )}
                {props.stateDescription && (
                    <div className="desc">{props.stateDescription}</div>
                )}
                {props.stateButtonText && props.stateButtonActions && (
                    <button
                        type="button"
                        className="w-button w-button-primary"
                        onClick={props.stateButtonActions}
                    >
                        <i className="far fa-plus"></i>{" "}
                        {props.stateButtonText}
                    </button>
                )}
            </div>
        </div>
    );
};

export default EmptyState;
